export enum ReservationStatus {
  cancelled = 0,
  active = 1,
  fulfilled = 2,
}
